import { useCallback, useState } from 'react';
export const useControllableState = ({ value: controlledValue, defaultValue, setValue: setControlledValue = () => null, }) => {
    const [internalState, setInternalState] = useState(defaultValue);
    const isControlled = controlledValue !== undefined;
    const value = isControlled ? controlledValue : internalState;
    const setValue = useCallback((nextValue) => {
        if (!isControlled) {
            setInternalState(nextValue);
        }
        const setter = nextValue;
        const valueToSet = typeof nextValue === 'function' ? setter(controlledValue) : nextValue;
        if (valueToSet !== controlledValue)
            setControlledValue(valueToSet);
    }, [isControlled, controlledValue, setControlledValue]);
    return [value, setValue];
};
